import React from 'react';
import { Popup, EnhancedTable } from 'components';
import { allTrackers } from 'consts';

const formatTrackerData = (idx) => (row, _col) => {
  const cnt = row.tracker_cnt[idx];
  if (!cnt) return '--';
  const stay = Math.ceil(row.tracker_stay[idx]);
  const bounce = row.tracker_bounce[idx];
  const landingRate = (100*cnt/row.landing).toFixed(1);
  const all = [landingRate+'%', stay+'s'];
  if (bounce > 0) all.push((100*bounce/cnt).toFixed(1)+'%'); // bounce rate
  return all.join(' / ');
};

const columns = ['date', 'imps', 'clicks', 'ctr', 'stay', 'landing_rate', 'jump2']
  .map(name => ({name}))
  .concat(allTrackers.map((name, i) => ({name, label: name, format: formatTrackerData(i)})));

const JobReport = ({job, onClose}) => {
  if (!job)
    return null;

  return (
    <Popup
      open={Boolean(job)}
      onClose={onClose}
      title={`${job.id} - ${job.name}`}
      styles={{minWidth: '80%', maxWidth: '95%'}}
    >
      <EnhancedTable
        stickyHeader
        columns={columns}
        dataUrl={`/reports/jobdaily?job=${job.id}`}
        dense={true}
      />
    </Popup>
  );
};

export default JobReport;
